import { selectXsrfToken } from 'modules/auth/selectors';
import * as auth from 'modules/auth';
import watchProgress from 'model/watchProgress';
import { Dispatch, GetState } from 'model/State';
import { fetchCartForOrder, fetchQuotesPost } from './actions';

export default async (dispatch: Dispatch, getState: GetState) => {
  const xsrfToken = await watchProgress(selectXsrfToken);

  if (!xsrfToken) {
    auth.actions.goToLogin();
    return;
  }

  const state = getState();
  const editedUuid = state.location.query?.editedUuid;
  dispatch(fetchQuotesPost(10, 0));
  if (editedUuid) {
    dispatch(fetchCartForOrder(editedUuid));
  }
};
